import { ArrowBack, ArrowForward } from '@mui/icons-material';
import { StyledButton } from './StyledButton';

export default function Btn({ href, noEndIcon, buttonName }) {
  return (
    <StyledButton
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      endIcon={noEndIcon ? null : <ArrowForward />}
      startIcon={noEndIcon ? <ArrowBack /> : null}
    >
      {buttonName}
    </StyledButton>
  );
}
